// src/pages/ContractorManagement.jsx
import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
} from "reactstrap";
import {
  FiUserPlus,
  FiClock,
  FiDownload,
} from "react-icons/fi";
import { IoLocationOutline } from "react-icons/io5";

import StatCard from "./StatCard";
import './Constarctor.css';
import { getCurrentcompleteDate } from "../../../../utils/getCurrentcompleteDate";
import { errorToast } from "../../../../_helper/helper";
import FiltersComponent from "../components/Filters/FiltersComponent";

import { Defaultpageifl } from "../../../../api/defaultpageifl";
import { Entrycameramonitor } from "../../../../api/EntryCameraMonitorifl";
import FaceDetectionsTablePage from "../face-detections/FaceDetectionsTablePage";
import ImageZoomSingleImage from "../../../Dashboards/AreaDashbaord/reports/Components/LiveAlertsCards/ImageZoomSingleImage";

const LOCAL_STORAGE_KEY = 'defaultPageFilters';

function EmployeeManagement() {
  const getInitialFilters = () => {
    const savedFilters = localStorage.getItem(LOCAL_STORAGE_KEY);
    return savedFilters
      ? JSON.parse(savedFilters)
      : {
        selectDate: 'date',
        time: '',
        week: '',
        date: getCurrentcompleteDate(),
        month: '',
        shift: '',
        starting: '',
        ending: ''
      };
  };

  const [filters, setFilters] = useState(getInitialFilters);
  const [callApi, setCallApi] = useState(false); // 🔁 API trigger

  //zoom image start
  const [showModal, setShowModal] = useState(false);
  const [imageUrl, setImageurl] = useState();
  const handleImageClick = (photo) => {
    console.log('photttt', photo)
    setImageurl(photo);
    setShowModal(!showModal);
  };
  //zoom image End

  const handleSave = () => {
    const updatedFilters = {
      selectDate: filters.selectDate,
      time: '',
      week: '',
      date: '',
      month: '',
      shift: filters.shift,
      starting: '',
      ending: '',
    };

    switch (filters.selectDate) {
      case 'date':
        if (!filters.date) return errorToast('Please select a Date!');
        updatedFilters.date = filters.date;
        break;
      case 'week':
        if (!filters.week) return errorToast('Please select a Week!');
        updatedFilters.week = filters.week;
        break;
      case 'month':
        if (!filters.month) return errorToast('Please select a Month!');
        updatedFilters.month = filters.month;
        break;
      case 'custom':
        if (!filters.starting || !filters.ending)
          return errorToast('Please select both Starting and Ending Dates!');
        updatedFilters.starting = filters.starting;
        updatedFilters.ending = filters.ending;
        break;
      default:
        break;
    }

    setFilters(updatedFilters);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updatedFilters));
    setCallApi(prev => !prev); // 🔁 Trigger API calls
  };

  const handleCancel = () => {
    const defaultFilters = {
      selectDate: 'date',
      time: '',
      week: '',
      date: getCurrentcompleteDate(),
      month: '',
      shift: '',
      starting: '',
      ending: ''
    };

    setFilters(defaultFilters);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(defaultFilters));
    setCallApi(prev => !prev); // 🔁 Reset to default triggers API
  };

  const [statsLoader, setStatsLoader] = useState(false);
  const [statsdata, setStatsdata] = useState([]);
  const [livealertsdata, setLivealertsdata] = useState([]);
  const [alertcounts, setalertcounts] = useState([])


  const getStatsData = async () => {
    const userData = JSON.parse(localStorage.getItem('userData'));

    const payload = {
      client_id: userData?.client?.id,
      factory_id: userData?.factory?.id,
      limit: "100",
      camera_id: "",
      employee_id: "",
      user_type: "contractor", // Specify user type as contractor
      filters: {
        date: filters?.date,
        week: filters?.week,
        month: filters?.month,
        starting: filters?.starting,
        ending: filters?.ending,
      }
    };

    const res = await Defaultpageifl.getStats(payload);

    if (res.status === 200) {
      setStatsdata(res.data.data);
      setStatsLoader(false);
    }
  };

  const getlivealertsdata = async () => {
    const userData = JSON.parse(localStorage.getItem('userData'));

    const payload = {
      client_id: userData?.client?.id,
      factory_id: userData?.factory?.id,
      limit: "100",
      offset: 0,
      camera_id: "",
      employee_id: "",
      filters: {
        date: filters?.date,
        week: filters?.week,
        month: filters?.month,
        starting: filters?.starting,
        ending: filters?.ending,
      },
    };

    const res = await Entrycameramonitor.getLiveAlertss(payload);

    if (res.status === 200) {
      setLivealertsdata(res.data.data.logs || []);
    }
  };


  // ..................

  const getlivecounts = async () => {
    setStatsLoader(true);
    const userData = JSON.parse(localStorage.getItem('userData'));

    const payload = {
      client_id: userData?.client?.id,
      factory_id: userData?.factory?.id,
      filters: {
        date: filters?.date,
        week: filters?.week,
        month: filters?.month,
        starting: "",
        ending: ""
      }
    };

    try {
      const res = await Defaultpageifl.getLivecounts(payload);

      if (res.status === 200) {
        setalertcounts(res.data.data);
        console.log(res);
        console.log("................getLivecounts..................");
      }
    } catch (error) {
      console.error("Error fetching stats:", error);
    } finally {
      setStatsLoader(false);
    }
  };





  useEffect(() => {
    const fetchAllData = async () => {
      try {
        setStatsLoader(true);
        await Promise.all([
          getStatsData(),
          getlivealertsdata(),
          getlivecounts()
        ]);
      } catch (error) {
        console.error("Error loading dashboard data:", error);
      } finally {
        setStatsLoader(false);
      }
    };

    fetchAllData();
  }, [callApi]); // 🔁 When filters change and save is clicked

  // Initial API load on mount
  useEffect(() => {
    setCallApi(prev => !prev);

  }, []);

  // .........main contractor page ......

  const statCards = [
    {
      title: "Total Contractors",
      value: statsdata?.total_contractors,
      color: "#14A44D",
      icon: IoLocationOutline,
    },
    {
      title: "Total SOP Followed",
      value: statsdata?.sop_followed,
      color: "#2563EB",
      icon: FiClock,
    },
    {
      title: "Total SOP Un Followed",
      value: statsdata?.sop_unfollowed,
      color: "#8B3DFF",
      icon: FiClock,
    },
    {
      title: "Total Entries",
      value: statsdata?.total_entries,
      color: "#FF6B00",
      icon: FiUserPlus,
    },
  ];

  const getFilterLabel = (filters) => {
    switch (filters.selectDate) {
      case 'date':
        return filters.date ? `Date: ${filters.date}` : '';
      case 'week':
        return filters.week ? `Week: ${filters.week}` : '';
      case 'month':
        return filters.month ? `Month: ${filters.month}` : '';
      case 'custom':
        if (filters.starting && filters.ending) {
          return `Custom: ${filters.starting} to ${filters.ending}`;
        }
        return '';
      default:
        return '';
    }
  };

  return (
    <Container fluid={true}>
      <br />
      <Row style={{ alignItems: "center", marginBottom: 4 }}>
        <Col>
          <h1 style={{ fontSize: 24, fontWeight: 600, color: "#1D67AA", margin: 0 }}>
            Contract Management
          </h1>
          <p style={{ fontSize: 14, color: "#535353", marginTop: 4 }}>
            {getFilterLabel(filters)}
          </p>
        </Col>
        <Col xs="12" xl="9" className="d-flex flex-wrap justify-content-end align-items-end">
          <FiltersComponent
            setFilters={setFilters}
            filtersConfig={[
              { key: "selectDate", options: ["date", "week", 'month', 'custom'], placeholder: "date" },
            ]}
            handleSave={handleSave}
            handleCancel={handleCancel}
            filters={filters}
          />
        </Col>
      </Row>

      <Row style={{ gap: 16, marginBottom: 24 }}>
        {statCards.map((card) => (
          <Col
            key={card.title}
            xs="12" sm="6" md="4"
            style={{ minWidth: 220, flex: "1 1 0" }}
          >
            <StatCard statsLoader={statsLoader} {...card} Icon={card.icon} />
          </Col>
        ))}
      </Row>

      <FaceDetectionsTablePage
        handleImageClick={handleImageClick}
        statsLoader={statsLoader} />

      {showModal && (
        <ImageZoomSingleImage
          photo={imageUrl}
          setShowModal={setShowModal}
        />
      )}
    </Container>
  );
}

export default EmployeeManagement;
